export default __webpack_public_path__ + "static/media/Thumbnail-Newsletter-4.10847a8b.png";